// 商品詳細・swiper

const recommendProductAirtist = new Swiper('.recommend_artist_swiper', {
  slidesPerView: 'auto',
  spaceBetween: 24,
  grabCursor: true,
  slidesPerView: 2.9,
  breakpoints: {
    990: {
      spaceBetween: 48,
      slidesPerView: 5.5,
    },
    750: {
      spaceBetween: 48,
      slidesPerView: 4.5,
    },
  },
  navigation: {
    nextEl: '.recommend_artist_swiper_wrapper .swiper-button-next',
    prevEl: '.recommend_artist_swiper_wrapper .swiper-button-prev',
  },
});


//　[商品詳細] 〇〇の他の作品
//　sections/custom-productdetail-venderotherproduct.liquid
//　[商品詳細]おすすめ
//　sections/custom-productdetail-osusume.liquid
const productlistSlideAreas = document.querySelectorAll('.j-productlistSlideArea');

productlistSlideAreas.forEach((productlistSlideArea, index) => {
    // 上記タグに対して、複数のswiperがあるため、動的にクラス名を作成
  const className = `j-productlistSlideArea_${index + 1}`;
  productlistSlideArea.classList.add(className);

  new Swiper(`.${className} .j-productlistSlide_pdetail`, {
    grid: {
      fill: 'row',
      rows: 2
    },
    slidesPerGroup: 1,
    slidesPerView: 2,
    spaceBetween: 8,
    navigation: {
      nextEl: `.${className} .swiper-button-next`,
      prevEl: `.${className} .swiper-button-prev`,
  },
    breakpoints: {
      750: {
        spaceBetween: 8,
        slidesPerView: 3.7,
      },
    },
  });
});
